import { useEffect, useRef } from "react";

// typed-js
import Typed from "typed.js";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import Navbar from "components/Navbar";
import { Link } from "react-router-dom";

function LandingPageHeader() {
  const typedJSRef = useRef(null);

  // Setting up typedJS
  useEffect(() => {
    const typedJS = new Typed(typedJSRef.current, {
      strings: ["software developer", "gamer", "hiker"],
      typeSpeed: 70,
      backSpeed: 70,
      backDelay: 500,
      startDelay: 500,
      loop: true,
    });

    return () => typedJS.destroy();
  }, []);

  return (
      <MKBox
        display="flex"
        alignItems="center"
        minHeight="70vh"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `linear-gradient(${rgba(gradients.dark.main, 0.6)} , ${rgba(gradients.dark.state, 0.6)}              ),              url("https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-kit-pro-react/material-design-background.jpg")            `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            mx="auto"
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {"Hello, this is Jackson Cagle"}
            </MKTypography>
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              a <span ref={typedJSRef} />
            </MKTypography>
            <MKTypography variant="body1" color="white" mt={1} mb={6} px={{ xs: 3, lg: 6 }}>
              This is my personal website where I share my projects and blog posts.
            </MKTypography>
            <MKButton color="info" 
              component={Link}
              to="/about-me"
            >
                About me
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
  );
}

export default LandingPageHeader;
